import { Stack } from '@mui/material';
import Chip from '@mui/material/Chip';
import './Filters.css';
import FilterSelect from '../FilterSelect/FilterSelect';

function Filters({ filters, setFilters, options }) {

    const addFilter = (filter) => {
        const newFilters = [...filters, filter];
        setFilters(newFilters);
    };

    const deleteFilter = (index) => {
        const newFilters = [...filters];
        newFilters.splice(index, 1);
        setFilters(newFilters);
    }

    const formatFilter = (filter) => {
        console.log(filter);
        if (filter.type === 'range') {
            if (filter.value[0] === filter.value[1]) {
                return filter.name + ' ' + filter.value[0];
            }
            return filter.name + ' ' + filter.value[0] + ' - ' + filter.value[1];
        } else if (filter.type === 'select') {
            return filter.name + ' ' + filter.value.join(', ');
        }
        return filter.name;
    }

    return (
        <div className='filters'>
            <FilterSelect options={options} addFilter={addFilter} activeFilters={filters}/>
            <Stack className='filters-stack' direction="row" spacing={1}>
                {filters.map((filter, index) => (
                    <Chip key={index} label={formatFilter(filter)} onDelete={() => deleteFilter(index)} />
                ))}
            </Stack>
        </div>
    )
}

export default Filters;